import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconCheckmark2Medium: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-1.5-IconCheckmark2Medium"><Path d="M20.4121 6.91895L9.24805 19.4492L3.58594 13.8877L4.9873 12.4609L9.15137 16.5498L18.9189 5.58789L20.4121 6.91895Z" fill="currentColor"/></CentralIconBase>;
});

export default IconCheckmark2Medium;
